var _linearGradient, _linearGradient2, _polygon, _polygon2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeAppDeploymentCenterStart48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad",
    "data-name": "Dark Blue Grad",
    x1: -1,
    y1: 15,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73b4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#6aaec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#529eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#2c839f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad-2",
    x1: 19,
    y1: 15,
    x2: 36,
    y2: 32,
    xlinkHref: "#Dark_Blue_Grad"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "4.5 37.5 4.5 9.5 24.5 23.5 4.5 37.5",
    stroke: "#464646",
    strokeLinejoin: "round",
    fill: "url(#Dark_Blue_Grad)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.5 37.5 24.5 9.5 44.5 23.5 24.5 37.5",
    stroke: "#464646",
    strokeLinejoin: "round",
    fill: "url(#Dark_Blue_Grad-2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeAppDeploymentCenterStart48);
export default __webpack_public_path__ + "static/media/typeAppDeploymentCenterStart48.e2e558654ecdd1334a96674fb8e7d608.svg";
export { ForwardRef as ReactComponent };